import React, { useState } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import $ from "jquery";
import {
    getFromLocalStorage,
    sendToLocalStorage,
    convertDate,
    isSimpleNavigation,
    str_replace, strstr, isset,
    removeNestedNullUndefined
} from './Utilities';

import ReportsCriteria from './ReportsCriteria';
import ReportsNavigation from './ReportsNavigation';
import BrandList from './BrandList';
import SegmentList from './SegmentList';
import ActivityList from './ActivityList';
import ApplicationList from './ApplicationList';

const md5 = require('md5');

class ReportsButtons extends React.Component {
    constructor(props){
        super(props);

        this.SubmitButton = React.createRef();

        this.state = {
           "prevText": null,
           "nextText": null,
           "submitButton": false,
           "steps": props.steps
        };
    }

    componentDidMount(){
        this.setState({
           "prevText": this.props.prevText ? this.props.prevText : null,
           "nextText": this.props.nextText ? this.props.nextText : null,
           "submitButton": this.props.submitButton ? this.props.submitButton : false,
        });
    }

    displayprev(){
        if(this.state.prevText){
            return (
               <li className="previous list-inline-item">
                    <button type="button" className="btn btn-light" onClick={() => this.onClick("prev")}>
                        <i className="mdi mdi-arrow-left me-1"></i> Back to {this.state.prevText}
                    </button>
                </li>
            );
        }
    }

    displayNext(){
        if(this.state.nextText){
            return (
               <li className="next list-inline-item float-end">
                    <button type="button" className="btn btn-primary" data-type="next" onClick={() => this.onClick("next")}>
                        Next: {this.state.nextText} <i className="mdi mdi-arrow-right ms-1"></i>
                    </button>
                </li> 
            );
        }
    }

    displaySubmit(){
        if(this.state.submitButton){
            return (
                <li className="list-inline-item float-end">
                    <a type="button" id="SubmitReportCriteria" ref={this.SubmitButton} className="btn btn-success" onClick={() => this.onClick("submit")}>Submit</a>
                </li>
            );
        }
    }

    onClick(action){
        if(action === "submit"){
            if(!$(this.SubmitButton.current).attr("disabled")){//only submit once
                $(this.SubmitButton.current).css("background-color", "grey");
                $(this.SubmitButton.current).attr("disabled", "disabled");
                this.props.handleSubmit(action);
            }
        } else if (action === "clear") {
            var data = {};
            sendToLocalStorage("report_data", data);
            window.location.href = "/dashboard/reports";
            return;
        } else {
            this.handleNavigation(action)
        }
    }

    handleNavigation(action){
        var currentTab = this.props.currentTab;
        var current = "";
        Object.entries(this.state.steps).filter(function(step, index){
            if(step[0] === currentTab) current = step;
        });

        if(action === "next"){
            var next = "";
            Object.entries(this.state.steps).filter(function(step, index){
                if((current[1].order + 1) === step[1].order) next = str_replace("Tab", "", step[0]);
            });
            this.props.handleNavigation(next); //send to parent
        }
        else if(action === "prev"){
            var prev = "";
            Object.entries(this.state.steps).filter(function(step, index){
                if((current[1].order - 1) === step[1].order) prev = str_replace("Tab", "", step[0]);
            });
            this.props.handleNavigation(prev); //send to parent
        }
    }

    render() {
        if(this.state.nextText || this.state.prevText){
            return (
                <ul className="pager wizard mb-0 list-inline text-end mt-2">
                    {this.displaySubmit()}  
                    {this.displayprev()} 
                    {this.displayNext()}  
                    <li className="clear list-inline-item float-end">
                        <button type="button" className="btn btn-danger ClearReportCriteria" onClick={() => this.onClick("clear")}>Start over</button>
                    </li>
                </ul>
            );
        } else {
            return (<div className="react-loading horizontal"></div>);
        }
    }
}

//Tab 1
class ReportTypeTab extends React.Component {

    constructor(props){
        super(props);

        this.tabName = "ReportTypeTab";
        var reports = getFromLocalStorage("reports_dropdown");

        this.state = {
            "reports": reports,
            "status": props.status,
            "reportType": props.value,
            "simpleNav": props.simpleNav,
            "displayApps": false,
            "steps": props.steps
        }
    }

    componentDidMount(){
        this.setState({
           displayApps: $("#MultiApp").attr("display")
        });

        if(Object.keys(this.state.reports).length === 0) this.getData();
    }

    getData(){     
        axios.get("DashboardPage_Controller/getAvailableReports?viaAjax=1&turnoffdebug=1")
            .then(response => this.formatData(response.data));
    }

    formatData(data){
        data = sendToLocalStorage("reports_dropdown", data);
        this.setState({
            "reports": data
        });
    }

    changeReport = (event) => {
        console.log("report type change report: "+event.target.value);
        this.setState({
            reportType: event.target.value,
            simpleNav: isSimpleNavigation(event.target.value)
        });
        this.props.setValues(this.tabName, {"ReportType": event.target.value});
    }

    changeApplication = (data) => {
        this.props.setValues(this.tabName, {"Application": data});
    }

    //pass to parent
    handleSubmit = () => {this.props.handleSubmit()} 
    handleNavigation = (step) => {this.props.handleNavigation(step)} 

    render() {
        var nextText = (this.state.simpleNav) ? "Pick dates" : "Choose brands";
        var displayApps = !JSON.parse(this.state.displayApps) ? "show" : "hide";

        if(Object.keys(this.state.reports).length > 0){
            return (
                <div className={"tab-pane "+this.state.status} id="ReportType">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="col-md-3 col-form-label"> Report type</label>
                            <select required className="form-control" id="ReportSelector" value={this.state.reportType} onChange={this.changeReport.bind()}>
                                {Object.entries(this.state.reports).map(function(obj, key){
                                    return <option key={obj[0]} value={obj[0]}>{obj[1].Title}</option>
                                })}
                            </select>
                        </div>
                    
                        <div className={"col-12 mb-3 "+displayApps} id="AppSelectorHolder">
                            <label className="col-12 col-form-label">Choose Application (optional):</label>
                            <ApplicationList type="select" value={this.props.application} onChange={this.changeApplication.bind(this)} />
                        </div>
                    </div>

                    <ReportsButtons 
                        key={nextText} 
                        nextText={nextText} 
                        submitButton={true} 
                        handleSubmit={this.handleSubmit.bind(this)} 
                        handleNavigation={this.handleNavigation.bind(this)} 
                        steps={this.state.steps} 
                        currentTab={this.tabName} //dont use this.constructor.name as it only works in dev
                    />
                </div>
            );
        } else {
            return(
                <div className="react-loading horizontal"></div>
            );
        }    
    }
}

//Tab 2
class ChooseBrandsTab extends React.Component {

    constructor(props){
        super(props);
        this.tabName = "ChooseBrandsTab";

        this.state = {
            "status": props.status,
            "steps": props.steps
        }
    }

    changeBrand = (brands) => {
        this.props.setValues(this.tabName, brands);
    }

    //pass to parent
    handleSubmit = () => {this.props.handleSubmit()} 
    handleNavigation = (step) => {this.props.handleNavigation(step)} 

    render(){
        if(this.state.status === "active"){//only load brand list if brand tab active
            return(
                <div className={"tab-pane "+this.state.status} id="ChooseBrands">
                    <div className="row">
                        <div className="col-12">
                            <BrandList maxbrands="5" onChange={this.changeBrand.bind(this)} status={this.state.status} key={this.state.status} />
                            <div className="brandlist-warning">
                                <span className="form-text">You can select multiple brands, up to 5 total.</span>
                                <span className="text-warning font-12">Warning: Changing brands will remove all activities previously chosen in step 3.</span>
                            </div>
                        </div>
                    </div>

                    <ReportsButtons 
                        prevText={"Report Types"} 
                        nextText={"Choose Activities"} 
                        submitButton={true} 
                        handleSubmit={this.handleSubmit.bind(this)} 
                        handleNavigation={this.handleNavigation.bind(this)} 
                        steps={this.state.steps} 
                        currentTab={this.tabName} //dont use this.constructor.name as it only works in dev
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

//Tab 3
class ChooseActivitiesTab extends React.Component {

    constructor(props){
        super(props);
        this.tabName = "ChooseActivitiesTab";

        this.state = {
            "status": props.status,
            "simpleNav": props.simpleNav,
            "segment": {},
            "steps": props.steps
        }
    }

    changeSegment = (data) => {
        this.setState({
            segment: data.Segment
        });

        this.props.setValues(this.tabName, data);
    }

    changeActivity = (data) => {
        this.props.setValues(this.tabName, data);
    }

    generateKey(label){
        return md5(label+this.state.segment?.ID+this.state.status);
    }

    //pass to parent
    handleSubmit = () => {this.props.handleSubmit()} 
    handleNavigation = (step) => {this.props.handleNavigation(step)} 

    render(){
        if(this.state.status === "active"){//only load activities if tab is active
            return(
                <div className={"tab-pane "+this.state.status} id="ChooseActivities" key={this.state.status}>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <h5 className="card-title">Choose Segment (optional)</h5>
                            <label className="col-12 col-form-label">Segment:</label>
                            <SegmentList type="select" onChange={this.changeSegment.bind(this)} IgnoreSegmentFilters="true" status={this.state.status} key={this.state.status} />
                        </div>

                        <div className="col-12">
                            <h5 className="card-title choose-activities-heading">Choose Activities<span className="segment-name"></span></h5>
                            <label className="col-12 col-form-label"> Members have done <strong>at least one of these</strong> activities<span className="text-danger">*</span></label>
                            <ActivityList type="AnyOf" key={this.generateKey("AnyOf")} onChange={this.changeActivity.bind(this)} status={this.state.status} />                        
                            <div className="activitylist-warning"><span className="form-text">You can select multiple activities.</span></div>
                        </div>

                        <div className="col-12">
                            <label className="col-12 col-form-label mt-2"> Members have done <strong>all of these</strong> activities</label>
                            <ActivityList type="AllOf" key={this.generateKey("AllOf")} onChange={this.changeActivity.bind(this)} status={this.state.status} />
                            <div className="activitylist-warning"><span className="form-text">You can select multiple activities.</span></div>
                        </div>

                        <div className="col-12">
                            <label className="col-12 col-form-label mt-2"> Members have done <strong>none of these</strong> activities</label>
                            <ActivityList type="NoneOf" key={this.generateKey("NoneOf")} onChange={this.changeActivity.bind(this)} status={this.state.status} />
                            <div className="activitylist-warning"><span className="form-text">You can select multiple activities.</span></div>
                        </div>
                    </div> 
                    <ReportsButtons 
                        prevText={"Brands"} 
                        nextText={"Pick Dates"} 
                        submitButton={true} 
                        handleSubmit={this.handleSubmit.bind(this)} 
                        handleNavigation={this.handleNavigation.bind(this)} 
                        steps={this.state.steps} 
                        currentTab={this.tabName} //dont use this.constructor.name as it only works in dev
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

//Tab 4
class DateRangeTab extends React.Component {

    constructor(props){
        super(props);
        this.tabName = "DateRangeTab";

        this.state = {
            "status": props.status,
            "simpleNav": props.simpleNav,
            "range": {"start": null, "end": null},
            "rangeDisabled": true,
            "value": props.values,
            "steps": props.steps
        }
    }

    componentDidMount(){
        if(this.state.value){
            var rangeRegex = /(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[1,2])\/(19|20)\d{2}/; //checks if date range (eg. 14/08/2024-16/08/2024)
            if(isset(this.state.value) && this.state.value.match(rangeRegex)){
                $("#DateRange input.CustomDateRange").click();
                var range = this.state.value;
                range = range.split("-");
                this.setState({
                    rangeDisabled: false,
                    range: {start: range[0], "end": range[1]}
                });
            } else {
                $("#DateRange input[value='"+this.state.value+"']").click();
            }
        }
    }

    changeDateRange = (value, type) => {
        if(type === "start" || type === "end"){
            var range = this.state.range;
            if(type === "start") range.start = convertDate(value);
            if(type === "end") range.end = convertDate(value);
            this.setState({
                "range": range,
                "value": range.start+"-"+range.end
            });
            if(range.start && range.end){
                this.props.setValues(this.tabName, {"Range" : range});// send to parent
            }
        } else {
            if(value.target.value === "CustomDateRange"){//not an actual value, clicking radio just enables range fields
                this.setState({
                    rangeDisabled: false
                });
                var range = this.state.range;
                if(range.start && range.end){//resend if already populated and we switch back to it
                    this.setState({
                        value: range.start+"-"+range.end
                    });
                    this.props.setValues(this.tabName, {"Range" : range});// send to parent
                }
            } else {
                this.setState({
                    rangeDisabled: true
                });
                this.props.setValues(this.tabName, {"Period" : value.target.value}); //send to parent
            }          
        }
    }

    //pass to parent
    handleSubmit = () => {this.props.handleSubmit()} 
    handleNavigation = (step) => {this.props.handleNavigation(step)} 

    render(){
        var prevText = (this.state.simpleNav) ? "Report Types" : "Choose Activities";

        return(
            <div className={"tab-pane "+this.state.status} id="DateRange" key={this.state.status+JSON.stringify(this.state.value)}>
                <div className="row m-2">
                    <div className="col-12">
                        <label className="col-md-3 col-form-label"> Pick a date range</label>
                    </div>
                </div>
                <div className="row date-input">
                    <div className="form-check col-md-2">
                        <input className="form-check-input" type="radio" name="daterange" value="24+HOUR" onChange={this.changeDateRange.bind(this)} id="flexRadioDefault1" />
                        <label className="form-check-label">
                            Last 24 hours
                        </label>
                    </div>
                    <div className="form-check col-md-2">
                        <input className="form-check-input" type="radio" name="daterange" value="7+DAY" onChange={this.changeDateRange.bind(this)} id="flexRadioDefault2" />
                        <label className="form-check-label">
                            Last 7 days
                        </label>
                    </div>
                    <div className="form-check col-md-2">
                        <input className="form-check-input" type="radio" name="daterange" value="30+DAY" onChange={this.changeDateRange.bind(this)} id="flexRadioDefault3" />
                        <label className="form-check-label">
                            Last 30 days
                        </label>
                    </div>
                    
                    <div className="col-md-5">
                        <div className="form-check col-md-3">
                            <input className="form-check-input CustomDateRange" type="radio" name="daterange" onChange={this.changeDateRange.bind(this)} value="CustomDateRange" id="flexRadioDefault4" />
                            <label className="form-check-label" style={{minWidth: '300px'}}>
                                Or pick custom range: <small>(d/m/Y)</small>
                            </label>                                                    
                        </div>
                        <ReportDatePicker 
                            key={this.state.rangeDisabled+this.state.value} 
                            value={this.state.value} 
                            onSelect={this.changeDateRange.bind(this)} 
                            rangeDisabled={this.state.rangeDisabled} />
                    </div>
                </div>
                <ReportsButtons 
                    prevText={prevText} 
                    nextText={"Other Criteria"} 
                    submitButton={true} 
                    handleSubmit={this.handleSubmit.bind(this)} 
                    handleNavigation={this.handleNavigation.bind(this)} 
                    steps={this.state.steps} 
                    currentTab={this.tabName} //dont use this.constructor.name as it only works in dev
                />
            </div>
        );
    }
}

const ReportDatePicker = (props) => {
    var [startDate, setStartDate] = useState(new Date());
    var [endDate, setEndDate] = useState(new Date());
    let dateFormat = "dd/MM/yyyy";

    // load existing values if present
    var values = props.value ? props.value : null;
    if(values && strstr(values, "-")){
        var range = values.split('-');
        //put dates back into a format datepicker can understand
        if(range[0] !== "undefined"){
            var start = range[0].split('/');
            startDate = new Date(start[2]+"-"+start[1]+"-"+start[0]);
        }
        if(range[1] !== "undefined"){
            var end = range[1].split('/');
            endDate = new Date(end[2]+"-"+end[1]+"-"+end[0]);
        }
    }

    return (
        <div className="reports-form-daterange">
            <DatePicker
                className="form-control col-md-2 start"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                onSelect={(date) => props.onSelect(date, "start")}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                disabled={props.rangeDisabled}
                dateFormat={dateFormat}
            />
            <div className="divider">
                <p>to</p>
            </div>
            <DatePicker
                className="form-control col-md-2 end"
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                onSelect={(date) => props.onSelect(date, "end")}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                disabled={props.rangeDisabled}
                dateFormat={dateFormat}
            />
        </div>
    );
};

//Tab 5
class OtherCriteriaTab extends React.Component {

    constructor(props){
        super(props);

        this.tabName = "OtherCriteriaTab";
        this.ChannelSelect = React.createRef();
        this.CountrySelect = React.createRef();

        //get lists from cache if available
        let channel_list = getFromLocalStorage("channel_list");
        let country_list = getFromLocalStorage("country_list");

        var values = {};//initiate data structure to avoid errors
        values.Channels = props.values.Channels ? props.values.Channels : {};
        values.Country = props.values.Country ? props.values.Country : {};
        values.Age = props.values.Age ? props.values.Age : {};
        values.Gender = props.values.Gender ? props.values.Gender : {};
        values.Score = props.values.Score ? props.values.Score : {};
        values.Keyword = props.values.Keyword ? props.values.Keyword : "";

        this.state = {
            "status": props.status,
            "values": values,
            "channels": channel_list,
            "countries": country_list,
            "steps": props.steps
        }
    }

    componentDidMount(){
        this.getData();
    }

    getData(){
        //get channels
        if(Object.keys(this.state.channels).length === 0){//only lookup if not cached
            axios.get("DashboardPage_Controller/getChannelsDropDown?viaAjax=1&turnoffdebug=1")
                .then(response => this.formatData({"channels": response.data}));
        } else {
            this.formatData(this.state);
        }

        //get countries
        if(Object.keys(this.state.countries).length === 0){
            axios.get("DashboardPage_Controller/getCountriesDropDown?viaAjax=1&turnoffdebug=1")
                .then(response => this.formatData({"countries": response.data})); 
        } else {
            this.formatData(this.state);
        }  
    }

    formatData(data){
        const parent = this;
        if(data.channels){
            data.channels = sendToLocalStorage("channel_list", JSON.stringify(data.channels));//add to cache
            this.setState({
                channels: data.channels
            });
            $(this.ChannelSelect.current).select2({
                multiple: true,
            });
            $(this.ChannelSelect.current).on('select2:select select2:unselect', function () {
                parent.addValues($(this).val(), "Channels");
            });
            if(this.state.values.Channels) {
                $(this.ChannelSelect.current).val(this.state.values.Channels[0]);
                $(this.ChannelSelect.current).trigger('change');
            }
        }
        if(data.countries){
            data.countries = sendToLocalStorage("country_list", JSON.stringify(data.countries));//add to cache
            this.setState({
                countries: data.countries
            });
            $(this.CountrySelect.current).select2({
                multiple: true,
            });
            $(this.CountrySelect.current).on('select2:select select2:unselect', function () {
                parent.addValues($(this).val(), "Country");
            });
            if(this.state.values.Country) {
                $(this.CountrySelect.current).val(this.state.values.Country[0]);
                $(this.CountrySelect.current).trigger('change');
            }
        }
    }

    addValues = (obj, field) => {
        if(!field) field = obj.target.id;
        var criteria = {};

        if(field === "Channels" || field === "Country"){
            criteria[field] = obj;
        } else {// Age, Gender, Score, Keyword
            criteria[field] = obj.target.value;
        }

        //combine with existing
        var values = this.state.values;
        values[field] = criteria[field];
        this.setState({
            "values" : values
        });

        this.props.setValues(this.tabName, criteria); //send to parent
    }

    //pass to parent
    handleSubmit = () => {this.props.handleSubmit()} 
    handleNavigation = (step) => {this.props.handleNavigation(step)} 

    render(){
        if(this.state.status === "active"){//only load countries and channels when tab is active
            return(
                <div className={"tab-pane "+this.state.status} id="OtherCriteria">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="col-12 col-form-label"> Channels</label>
                            <select className="form-control" ref={this.ChannelSelect} id="Channels">   
                                {Object.entries(this.state.channels).map(function(obj, key){
                                    return <option key={key} value={obj[1].Value}>{obj[1].Label}</option>
                                })}
                            </select>
                            <span className="form-text">You can select multiple channels.</span>
                        </div>
                        <div className="col-md-6">
                            <label className="col-12 col-form-label"> Countries</label>
                            <select className="form-control" ref={this.CountrySelect} id="Country">
                                {Object.entries(this.state.countries).map(function(obj, key){
                                    return <option key={key} value={obj[1].Value}>{obj[1].Label}</option>
                                })}
                            </select>
                            <span className="form-text">You can select multiple countries.</span>
                        </div>
                    </div>
                    <div className="row other-criteria-second-row">
                        <div className="col-md-3" id="AgeGroup">
                            <label className="col-form-label">
                                Age
                            </label>
                            <select className="form-select" id="Age" defaultValue={this.state.values.Age[0]||""} onChange={this.addValues.bind(this)}>
                               <option value="">Select range</option>
                               <option value="15-24">15 to 24 years old</option>
                               <option value="25-34">25 to 34 years old</option>
                               <option value="35-45">&gt; 35 to 45 years old</option>
                               <option value="46-60">&gt; 46 to 60 years old</option>
                               <option value="61+">&gt; 61 years old</option>
                            </select>
                        </div>
                        <div className="col-md-3" id="GenderGroup">
                            <label className="col-form-label">
                                Gender
                            </label>
                            <select className="form-select" id="Gender" defaultValue={this.state.values.Gender[0]||""} onChange={this.addValues.bind(this)}>
                               <option value="">Select gender</option>
                               <option value="F">Female</option>
                               <option value="M">Male</option>
                               <option value="N">Non-binary</option>
                               <option value="O">Other</option>
                            </select>
                        </div>
                        <div className="col-md-3" id="ScoreGroup">
                            <label className="col-form-label">
                                Member score
                            </label>
                            <select className="form-select" id="Score" defaultValue={this.state.values.Score[0]||""} onChange={this.addValues.bind(this)}>
                               <option value="">Select range</option>
                               <option value="0-50">0-50</option>
                               <option value="51-100">51-100</option>
                               <option value="100+">100+</option>
                            </select>
                        </div>
                        <div className="col-md-3" id="KeywordGroup">
                            <label className="col-form-label">
                                <span className="mdi mdi-magnify"></span> Search
                            </label>
                            <input type="text" className="form-control" value={this.state.values.Keyword||""} id="Keyword" onChange={this.addValues.bind(this)} placeholder="Eg. username, email, url, hashtag..." />
                        </div>
                    </div>
                        
                    <ReportsButtons 
                        prevText={"Pick Dates"} 
                        submitButton={true} 
                        handleSubmit={this.handleSubmit.bind(this)} 
                        handleNavigation={this.handleNavigation.bind(this)} 
                        steps={this.state.steps} 
                        currentTab={this.tabName} //dont use this.constructor.name as it only works in dev
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

class ReportsForm extends React.Component {
    
    constructor(props){
        super(props);

        //initial data from local storage
        var data = getFromLocalStorage("report_data");
        if(!data) data = {};
        
        //get report from url
        var url = new URL(window.location.href);
        if(url.searchParams.get('report')){
            data.ReportType = url.searchParams.get('report');
        } 
        if(!data.ReportType) data.ReportType = "active-members";//default
        if(!data.DateRange) data.DateRange = "7+Day";//default

        //determine whether report type requires simple nav
        var simpleNav = data.ReportType ? isSimpleNavigation(data.ReportType.toLowerCase()) : false;  

        //initial tabs
        var tabs = this.getTabs(simpleNav);

        //set active tab by url hash        
        var hash = window.location.hash;
        if (hash) {
            var hashTabName = str_replace("#", "", hash)+"Tab";
            Object.entries(tabs).filter(function(tab, key){
                if(tab[0] === hashTabName) tab[1].status = "active";
                else tab[1].status = "inactive";
            });
        }

        this.state = {
            tabs: tabs,
            values: data,
            simpleNav: simpleNav
        }
    }

    componentDidMount(){
        //remove report param from url
        var url = new URL(window.location.href);
        if(url.searchParams.get('report')){
            url.searchParams.delete('report');
            window.history.replaceState({}, '', url.toString());
        }       
    }

    // sets initial active/inactive status, after that it is controlled by jquery to avoid unneccesary reload triggers
    getTabs(simpleNav) {
        var tabs = {
            "ReportTypeTab": {"order": 1, "status" : "active"},
            "ChooseBrandsTab": {"order": 2, "status": "inactive"},
            "ChooseActivitiesTab": {"order": 3, "status": "inactive"},
            "DateRangeTab": {"order": 4, "status": "inactive"},
            "OtherCriteriaTab": {"order": 5, "status": "inactive"}
        };
        if(simpleNav){
            tabs['ChooseBrandsTab'].order = tabs['ChooseBrandsTab'].order = -1;//negative order means they can't be navigated to but we can still see status etc
            tabs['ChooseActivitiesTab'].order = tabs['ChooseActivitiesTab'].order = -2;
            tabs["DateRangeTab"].order = (tabs["DateRangeTab"].order - 2);
            tabs["OtherCriteriaTab"].order = (tabs["OtherCriteriaTab"].order - 2);
        }
        return tabs;
    }

    //triggered as fields are set on various tabs
    setValues = (tab, values) => {
        var data = this.state.values;

        //we only change these two if report type changes
        var simpleNav = this.state.simpleNav;
        var tabs = this.state.tabs;

        if(tab === "ReportTypeTab"){
            if(values.ReportType){
                var data = {};//clear all other criteria when changing report type
                data.DateRange = "7+Day";
                data.ReportType = values.ReportType;

                //clear favourite report on report type change
                axios.get("ReportsPage_Controller/clearFavoriteReportViaAjax");
                
            } else if(values.Application){
                if(values.Application.Default) delete(data.Application); 
                else data.Application = values.Application;
            }

            //reset nav and next buttons
            var simpleNav = isSimpleNavigation(data.ReportType.toLowerCase());
            var tabs = this.getTabs(simpleNav);

        } else if (tab === "ChooseBrandsTab"){
            if(!data.ChooseBrands) data.ChooseBrands = {};
            data.ChooseBrands = values;
            ActivityList.apiData = null;
            ActivityList.apiPromise = null;
        } else if (tab === "ChooseActivitiesTab"){
            if(!data.ChooseActivities) data.ChooseActivities = {};

            if(values.Segment){
                if(!data.ChooseActivities.Segment) data.ChooseActivities.Segment = {};
                if(values.Segment.ID === "All") delete(data.ChooseActivities.Segment);
                else data.ChooseActivities.Segment = values.Segment;
                ActivityList.apiData = null;
                ActivityList.apiPromise = null;
            } else {
                if(Object.keys(values).length > 0){
                    var type = Object.values(values)[0].type;
                    $(values).filter(function(index, obj){
                        if(!obj.ID) delete(values[index])
                    });
                }          
                data.ChooseActivities[type] = removeNestedNullUndefined(values);
            }
        } else if (tab === "DateRangeTab"){
            if(values.Range) data.DateRange = values.Range.start+"-"+values.Range.end;
            else data.DateRange = values.Period;
        } else if (tab === "OtherCriteriaTab"){
            if(!data.OtherCriteria) data.OtherCriteria = {};
            var field = Object.keys(values)[0];
            data.OtherCriteria[field] = Object.values(values);
        }

        // console.log(data);
        data = sendToLocalStorage("report_data", data);

        this.setState({
            "values": data,
            "simpleNav": simpleNav,
            "tabs": tabs
        });
    }

    handleSubmit = () => {
        var data = this.state.values;
        data = sendToLocalStorage("report_data", data);
        return this.sendToSession(data);//will redirect after sending data
    }

    sendToSession(data) {
        //axios.post malforms the data so use ajax
        $.ajax({
            url: 'ReportsPage_Controller/setReportFilters',
            type: "POST",
            data: data,
            timeout: 100000,
            cache: false,
            success: function(result) {
                window.location.href = "/dashboard/reports/results";
                return;
            }
        });
    }

    handleNavigationEvents(step){
        var tabs = this.state.tabs;
        var tab_name = step+"Tab";
        $(Object.entries(tabs)).each((index, tab) => {
            if(tab[0] === tab_name) tab[1].status = "active";
            else tab[1].status = "inactive";
        });
        this.setState({
            tabs: tabs
        });
    }

    //factor important info into key so it will refresh if any changes
    generateKey(label){
        if(label === "ReportsNavigation") return md5(label+this.state.values.ReportType+JSON.stringify(this.state.tabs));
        if(label === "ReportsCriteria") return md5(label+JSON.stringify(this.state.values));

        //only load tab when tab becomes active
        if(strstr(label, "Tab")) return md5(label+this.state.tabs[label].status+this.state.simpleNav);
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="card no-bg mt-4 mb-5 ml--25 mr--25">
                            <div className="card-body">

                                <form>
                                    <div id="progressbarwizard">
                                        <div className="connecting-line"></div>

                                        <ReportsNavigation 
                                            key={this.generateKey("ReportsNavigation")}
                                            tabs={this.state.tabs} 
                                            reportType={this.state.values.ReportType} 
                                            handleNavigation={this.handleNavigationEvents.bind(this)}
                                        />
                                    
                                        <div className="ReportsForm tab-content b-0 pt-0 mb-0">
                                            {/*<div id="bar" className="progress mb-4">
                                                <div className="bar progress-bar progress-bar-striped progress-bar-animated bg-primary"></div>
                                            </div>*/}

                                            <ReportTypeTab 
                                                key={this.generateKey("ReportTypeTab")} 
                                                steps={this.state.tabs}
                                                status={this.state.tabs.ReportTypeTab.status} 
                                                simpleNav={this.state.simpleNav}
                                                value={this.state.values.ReportType}
                                                application={this.state.values.Application?.ID}
                                                setValues={this.setValues.bind(this)}
                                                handleSubmit={this.handleSubmit.bind()} 
                                                handleNavigation={this.handleNavigationEvents.bind(this)}
                                            />

                                            <ChooseBrandsTab 
                                                key={this.generateKey("ChooseBrandsTab")} 
                                                steps={this.state.tabs}
                                                status={this.state.tabs.ChooseBrandsTab.status} 
                                                setValues={this.setValues.bind(this)} 
                                                handleSubmit={this.handleSubmit.bind()} 
                                                handleNavigation={this.handleNavigationEvents.bind(this)}
                                            />
                                    
                                            <ChooseActivitiesTab 
                                                key={this.generateKey("ChooseActivitiesTab")} 
                                                steps={this.state.tabs}
                                                status={this.state.tabs.ChooseActivitiesTab.status} 
                                                simpleNav={this.state.simpleNav}
                                                setValues={this.setValues.bind(this)} 
                                                handleSubmit={this.handleSubmit.bind()} 
                                                handleNavigation={this.handleNavigationEvents.bind(this)}
                                            />

                                            <DateRangeTab 
                                                key={this.generateKey("DateRangeTab")} 
                                                steps={this.state.tabs}
                                                status={this.state.tabs.DateRangeTab.status} 
                                                simpleNav={this.state.simpleNav}
                                                values={this.state.values.DateRange || {}}
                                                setValues={this.setValues.bind(this)} 
                                                handleSubmit={this.handleSubmit.bind()} 
                                                handleNavigation={this.handleNavigationEvents.bind(this)}
                                            />

                                            <OtherCriteriaTab 
                                                key={this.generateKey("OtherCriteriaTab")}
                                                steps={this.state.tabs}
                                                status={this.state.tabs.OtherCriteriaTab.status} 
                                                values={this.state.values.OtherCriteria || {}}
                                                setValues={this.setValues.bind(this)} 
                                                handleSubmit={this.handleSubmit.bind()} 
                                                handleNavigation={this.handleNavigationEvents.bind(this)}
                                            />
                                            
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="ae-accordion ae-accordion-flush" id="ReportCriteriaSoFar">
                    <div className="ae-accordion-item">
                        <h2 className="accordion-header" id="flush-headingOne">
                            <button className="accordion-button show" type="button">
                                <i className="ae-arrow"></i>
                                Your criteria so far
                            </button>
                        </h2>
                        <div className="ae-accordion-collapse show criteria-holder mt-3">
                            <div className="ae-accordion-body criteria">  
                                <ReportsCriteria key={this.generateKey("ReportsCriteria")} values={this.state.values} />   
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default ReportsForm;
